import { apiClient } from './client';

export type CarrierProvider = 'dhl' | 'dpd' | 'gls' | 'sendcloud';

export interface CarrierCredentialHealth {
  provider: CarrierProvider;
  invalid_since: string | null;
  checked_at: string | null;
  last_error: string | null;
  check_enabled: boolean;
}

export interface CarrierCredentialHealthResponse {
  carriers: CarrierCredentialHealth[];
}

export interface SetCredentialCheckResponse {
  provider: CarrierProvider;
  check_enabled: boolean;
}

export const carrierCredentialHealthApi = {
  get: async (): Promise<CarrierCredentialHealthResponse> => {
    const response = await apiClient.get<CarrierCredentialHealthResponse>(
      '/logistics/credential-health',
    );
    return response.data;
  },

  setCheckEnabled: async (
    provider: CarrierProvider,
    checkEnabled: boolean,
  ): Promise<SetCredentialCheckResponse> => {
    const response = await apiClient.put<SetCredentialCheckResponse>(
      `/logistics/credential-health/${provider}`,
      { check_enabled: checkEnabled },
    );
    return response.data;
  },
};
